<template>
  <div class="review-list-cont">
    <ScrollBox @getData="getData">
      <div class="review-list-cont__box" v-if="listData">
        <router-link
          :to="{path: `/ReviewMaps?id=${item.maps_id}`}"
          tag="div"
          v-for="(item, index) in listData.mapsList"
          :key="index"
          class="item"
        >
          <div class="img-box">
            <img :src="item.maps_coverimg" alt />
          </div>
          <p>{{ item.maps_title }}</p>
        </router-link>
        <!-- <div
          @click="chooseMap(item.maps_id)"
          class="item"
          v-for="(item, index) in listData.mapsList"
          :key="index"
        >
          <div class="img-box">
            <img :src="item.maps_coverimg" alt />
          </div>
          <p>{{ item.maps_title }}</p>
        </div>-->
      </div>
    </ScrollBox>
  </div>
</template>
<script>
import ScrollBox from "@/components/ScrollBox";
import ReviewHttp from "../review";
export default {
  name: "review-home",
  data() {
    return {
      title: "小儿童美语二级",

      listData: null
    };
  },
  components: {
    ScrollBox
  },
  created() {
    this.$store.dispatch("setLoadingStatus", true);
    this.$emit('setTitleType', 'list')
    this.student_id = this.$store.state.currentChild.student_id;
    this.getMaps();
  },
  methods: {
    chooseMap(id) {
      this.getMapsResource(id);
    },
    // 获取 地图 列表
    getMaps() {
      ReviewHttp.getMaps({
        member_id: this.$store.state.member_id,
        token: this.$store.state.token,
        student_id: this.student_id
      }).then(res => {
        const { error, result } = res.data;
        if (error == 0) {
          this.listData = result.list[0];
          this.$emit('setTitleNav', result.list)
        }
        this.$emit("setReivewTitle", this.listData.classcode_name);
        this.$store.dispatch("setLoadingStatus", false);
      });
    },
    bakToPrev() {
      // this.$router.push({ path: "/StudyCenter" });
      console.log("bakToPrev");
    },
    getData() {
      console.log("getData");
    }
  }
};
</script>
<style lang="less" scoped>
.review-list-cont {
  height: 100%;
  .review-list-cont__box {
    width: 716px;
    margin: 0 auto;
    padding: 15px 0 15px;
    display: flex;
    flex-wrap: wrap;
    .item {
      width: 222px;
      margin-bottom: 15px;
      margin-right: 25px;
      &:nth-child(3n) {
        margin-right: 0;
      }
      .img-box {
        height: 298px;
        width: 100%;
        overflow: hidden;
        border-radius: 10px 10px 0 0;
        position: relative;
        img {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate3d(-50%, -50%, 0);
          width: 100%;
          min-height: 100%;
        }
      }
      p {
        height: 56px;
        padding: 15px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        background-color: #fff;
        border-radius: 0 0 10px 10px;
      }
    }
  }
  @media screen and (max-width: 780px) {
    .review-list-cont__box {
      width: 500px;
      .item {
        width: 150px;
        .img-box {
          height: 240px;
        }
        p {
          height: 40px;
        }
      }
    }
  }
  @media screen and (min-width: 1350px) {
    .review-list-cont__box {
      width: 1210px;
      .item {
        &:nth-child(3n) {
          margin-right: 25px;
        }
        &:nth-child(5n) {
          margin-right: 0;
        }
      }
    }
  }
  @media screen and (min-width: 1750px) {
    .review-list-cont__box {
      width: 1705px;
      .item {
        &:nth-child(3n),
        &:nth-child(5n) {
          margin-right: 25px;
        }
        &:nth-child(7n) {
          margin-right: 0;
        }
      }
    }
  }
}
</style>